__turbopack_context__.v({
  "carousel": "[event]-module-scss-module__NBO_Ja__carousel",
  "info": "[event]-module-scss-module__NBO_Ja__info",
  "internalCarousel": "[event]-module-scss-module__NBO_Ja__internalCarousel",
});
